<template>
    <div class="o-sms-modal-otg-success">
        <svg-icon
            original
            name="icons/success-mark-otg"
            class="sms-modal-otg-success-icon"
        />
        <span class="success-message">
            {{ message }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'OSmsModalOtgSuccess',
    props: {
        message: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />